export const fontFamily = 'Montserrat';

export const bigFontSize = '1.75rem';
export const fontSizeH1 = '1.5rem';
export const fontSizeH2 = '1.25rem';
export const fontSizeH3 = '1rem';
export const fontSize = '.938rem';
export const smallFontSize = '.813rem';
export const smallerFontSize = '.75rem';
export const tinyFontSize = '.625rem';

export const fontMedium = 500;
export const fontSemiBold = 600;
export const fontBold = 700;
